import React, { useEffect, useRef, useState } from "react";
import { createPortal } from "react-dom";
import { Image, FileText, X } from "lucide-react";
import { AssetFile } from "./CatalogAssets";
import styles from "./CatalogAssetIcons.module.css";

// [[Catalog Assets]] #obsidian-marker
export default function CatalogAssetIcons({ partNumber, materials = [] }) {
    materials = materials.map(material => ({ ...material, assets: (material.assets || []).filter(asset => asset.stored) }));
    const [kind, setKind] = useState(null);
    const closeRef = useRef(null);
    const triggerRef = useRef(null);
    useEffect(() => {
        if (!kind) return undefined;
        closeRef.current?.focus();
        const onKey = event => {
            if (event.key === "Escape") { event.preventDefault(); event.stopImmediatePropagation(); setKind(null); }
            if (event.key === "Tab") {
                const controls = [...closeRef.current.closest('[role="dialog"]').querySelectorAll('button, a[href], iframe')].filter(el => !el.disabled);
                const first = controls[0], last = controls[controls.length - 1];
                if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
                else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
            }
        };
        document.addEventListener("keydown", onKey, true);
        return () => { document.removeEventListener("keydown", onKey, true); triggerRef.current?.focus(); };
    }, [kind]);
    const available = type => materials.some(material => material.assets?.some(asset => asset.kind === type));
    if (!available("image") && !available("datasheet")) return null;
    const open = (event, type) => { event.stopPropagation(); triggerRef.current = event.currentTarget; setKind(type); };
    return <span className={styles.icons}>
        {available("image") && <button type="button" className={styles.icon} title="Просмотреть изображение" aria-label={`Изображение ${partNumber}`} onClick={event => open(event, "image")}><Image size={17} /></button>}
        {available("datasheet") && <button type="button" className={styles.icon} title="Просмотреть спецификацию PDF" aria-label={`Спецификация PDF ${partNumber}`} onClick={event => open(event, "datasheet")}><FileText size={17} /></button>}
        {kind && createPortal(<div className={styles.overlay} onClick={event => { event.stopPropagation(); if (event.target === event.currentTarget) setKind(null); }}>
            <section className={styles.dialog} role="dialog" aria-modal="true" aria-label={`${kind === "image" ? "Изображение" : "Спецификация PDF"} ${partNumber}`}>
                <header className={styles.header}><h3>{partNumber} — {kind === "image" ? "Изображение" : "Спецификация PDF"}</h3><button ref={closeRef} type="button" className={styles.icon} onClick={() => setKind(null)} aria-label="Закрыть просмотр"><X size={20} /></button></header>
                {materials.filter(material => material.assets.some(asset => asset.kind === kind)).map(material => <div className={styles.material} key={material.component_id}>
                    <h4>{material.manufacturer}</h4>
                    {material.assets.filter(asset => asset.kind === kind).map(asset => <AssetFile key={`${material.component_id}-${asset.kind}`} asset={asset} partNumber={partNumber} />)}
                </div>)}
            </section>
        </div>, document.body)}
    </span>;
}
